<script setup>
import { defineProps, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import PMListItemIndex from './Index.vue'
import PMListItemFloorForm from './FLoorForm.vue'
// import PMListItemForm from './Form.vue'

/** @type {import('vue').Ref<number|null>} */
const editId = ref(null)
/** @type {Props} */
const props = defineProps(['pmListId'])

/** @type {import('vue').Ref<InstanceType<typeof PMListItemIndex>>} */
const pmListItemIndexRef = ref(undefined)

onBeforeMount(() => {
  const { searchParams } = new URL(window.location.href)
  const queryEditId = parseInt(searchParams.get('pmListItem'), 10)
  if (queryEditId == null) return
  editId.value = queryEditId
})

const onAddFloorForm = () => {
  const controller = new AbortController()
  pmListItemIndexRef.value?.getPMListItems?.(controller)
  onBeforeUnmount(() => {
    controller.abort()
  })
}

// const onSuccessHandler = () => {

// }

// const onCancelHandler = () => {
//   const url = new URL(window.location.href)
//   url.searchParams.delete('pmListItem')
//   window.history.replaceState({}, '', url.href)
//   editId.value = null
// }
</script>
<style lang="sass" scoped>
.pm-list-item-template
  display: flex
  flex-direction: column
  gap: 10px
  .index
    flex: 1
.box-bubble
  border: 1px solid #cfcdcd
  padding: 10px
  border-radius: 10px
</style>
<template>
  <div class="pm-list-item-template">
    <div>
      <PMListItemFloorForm @onAddFloorForm="onAddFloorForm" :pmListId="pmListId" />
    </div>
    <div class="box-bubble index">
      <PMListItemIndex ref="pmListItemIndexRef" :pm-list-id="pmListId" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'PMListItemTemplate',
}
/**
 * @typedef {Object} Props
 * @property {number} [pmListId]
 */
</script>
